import { inject, Injectable } from '@angular/core';
import { filter, Observable, of } from 'rxjs';
import { parseJWT } from '@shared/utils/jwt.utils';
import { AbstractService } from '../abstracts/abstract.service';
import { AUTH_SESSION } from '@shared/di/auth-session.token';

@Injectable({
  providedIn: 'root'
})
export class JwtService extends AbstractService {
  private readonly session = inject(AUTH_SESSION);
  private _sub: number | null = null;

  constructor() {
    super();
    this.session.accessToken$.pipe(filter(value => value !== null)).subscribe((value: string) => {
      const decoded = parseJWT(value);
      if (decoded) {
        this._sub = Number((decoded.payload as any).sub);
        this.logger.debug('JwtService sub', this._sub);
      }
    });
  }

  get sub(): number | null {
    return this._sub;
  }

  get sub$(): Observable<number | null> {
    return of(this._sub);
  }

}
